import * as $ from 'jquery';
import * as angular from 'angular';

import {
  Component,
  Input,
  Inject,
  Host,
  SkipSelf,
  OnInit,
  OnChanges,
  OnDestroy,
  AfterViewInit,
  SimpleChanges,
} from 'ng-metadata/core';

import { DropComponent } from './drop.component';


/**
 * Search Component
 */
@Component({
  selector: 'gwDropContent',
  template: `
    <div class="gw-drop-content ng-animated"
         ng-if="$ctrl.drop.isOpen"
         ng-class="$ctrl.positionClass"
         ng-style="{ width: $ctrl.width + 'px' }">
      <ng-transclude></ng-transclude>
    </div>
  `,
  legacy: {
    transclude: true,
  },
})
export class DropContentComponent implements OnInit, AfterViewInit, OnDestroy {
  public manualDropClose;

  // Bindings
  @Input('<') width: number;
  @Input('@') position: string;

  // Properties
  positionClass: string;

  constructor(
     @Inject('gwDrop') @SkipSelf() private drop,
     @Inject('$scope') private $scope: ng.IScope,
     @Inject('$element') private $element: ng.IRootElementService,
     @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
  ) {}

  /**
   * Component ready
   */
  ngOnInit() {
    this.positionClass = this.position ? `on-${this.position}` : null;
  }

  ngAfterViewInit() {
    $(document).on('click.drop.outside touchstart.drop.outside', this.handleClick.bind(this));

    // Manual drop close trigger event
    this.manualDropClose = this.$scope.$on('drop.close', () => {
      this.drop.isOpen = false;
    });
  }

  ngOnDestroy() {
    $(document).off('click.drop.outside touchstart.drop.outside', this.handleClick.bind(this));

    this.manualDropClose();
  }

  handleClick(e: Event) {
    const $target = $(e.target);

    if ($target.closest('.gw-drop').length === 0) {
      this.$scope.$apply(() => {
        this.$rootScope.$broadcast('gw-close-drop');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/drop/drop-content.component.ts